import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { WizardStateRefinementItem } from "./refinement-items"

export const NoticeWizardStateRefinement = ({
  current_wizard_state_refinement,
  defaultRefinement,
  in_bfz_article,
  all_states,
  set_current_wizard_state_refinement,
  wizard_ref,
}) => {
  const { radar_image } = useStaticQuery(graphql`
    query {
      radar_image: file(name: { eq: "tender-wizard-radar" }) {
        childImageSharp {
          gatsbyImageData(
            width: 253
            formats: [AUTO, AVIF]
            layout: CONSTRAINED
            placeholder: BLURRED
          )
        }
      }
    }
  `)

  return (
    <div ref={wizard_ref}>
      <p className="title is-5 has-text-mitternachtsblau has-text-centered">
        Wo suchen Sie Aufträge?
      </p>
      <div className="columns">
        {!in_bfz_article ? (
          <div className="column is-4 has-text-centered is-hidden-mobile">
            <GatsbyImage
              {...{
                alt: "Ausschreibungs-Radar",
                image: radar_image?.childImageSharp?.gatsbyImageData,
              }}
            />
          </div>
        ) : null}
        <div className="column has-text-centered is-flex">
          <div className="columns is-gapless my-auto is-flex-grow-1">
            {[
              [...all_states.slice(0, all_states.length / 2)],
              [...all_states.slice(all_states.length / 2)],
            ].map((half_the_states, index) => {
              return (
                <div className="column is-6" key={"state-half-" + index}>
                  {half_the_states.map((label) => {
                    return (
                      <WizardStateRefinementItem
                        {...{
                          defaultRefinement,
                          isRefined:
                            current_wizard_state_refinement.includes(label),
                          current_wizard_state_refinement,
                          set_current_wizard_state_refinement,
                          label,
                          key: label,
                          all_states,
                        }}
                      />
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
